enum StoreAvailabilityProbabilityEnum {
	highInStock = 'HIGH_IN_STOCK',
	mediumInStock = 'MEDIUM_IN_STOCK',
	lowInStock = 'LOW_IN_STOCK',
	someLowOrOutOfStock = 'SOME_LOW_OR_OUT_OF_STOCK',
	outOfStock = 'OUT_OF_STOCK',
	notSoldAtStore = 'NOT_SOLD_AT_STORE',
	/** Single product - will show caption text for StoreSelector. */
	orderItemSingle = 'ORDER_ITEM_SINGLE',
	/** Multipe products - caption text for StoreSelector should be hidden. */
	orderItemMultiple = 'ORDER_ITEM_MULTIPLE'
}

export default StoreAvailabilityProbabilityEnum;
